<template>
  <div>
    <my-header>
      测试
    </my-header>
    <mediapipe
        ref="mediapipeRef"
        :hands-listens="handsListens"
        :pose-listens="['back', 'forward']"
        :select-listens="3"
        @select="select"
        @victory="victory"
        @back="back"
        @forward="forward"
        @okay="okay"
        @right="right"
        @wrong="wrong"
        @pose="pose"
    ></mediapipe>
    <van-button type="info" @click="takePhoto">拍照</van-button>
  </div>
</template>

<script>
import mediapipe from '@/views/components/mediapipe'
import { Button, Toast } from "vant";
export default {
  name: "mpTest",
  components: {
    [Button.name]: Button,
    mediapipe
  },
  data: function() {
    return {
      handsListens: []
    };
  },
  methods: {
    victory(){
      Toast('胜利！！')
    },
    takePhoto(){
      this.$refs.mediapipeRef.takePhoto().then(blob => {
        console.log(blob)
      })
    },
    back(){
      Toast('回退！')
    },
    forward(){
      Toast('前进！')
    },
    okay(){
      Toast('Okay！')
    },
    right(){
      Toast('right！')
    },
    wrong(){
      // this.handsListens = ['okay']
      Toast('wrong！')
    },
    pose(pose){
      // console.log(pose)
    },
    select(index){
      console.log(index)
    }
  }
}
</script>

<style scoped>

</style>
